export default __webpack_public_path__ + "static/media/Xarathrustra-minion-particle_0002_Div.1c3a5fc9.png";